'use strict';

// utility class
import ApplyClass from '../Utils/ApplyClass';

import Form from '../Controller/Form';

import Validate from '../View/Form/Validate';
import Submit from '../View/Form/Submit';
import ZenkakuToHankaku from '../View/Form/ZenkakuToHankaku';
import HasCounter from '../View/Form/HasCounter';
import Select2 from '../View/Form/Select2';
import Select2Wide from '../View/Form/Select2Wide';
import DatePicker from '../View/Form/DatePicker';
import CheckAll from '../View/Form/CheckAll';
import TelephoneNumber from '../View/Form/TelephoneNumber';
import Accordion from '../View/Form/Accordion';
import ToggleSelect from '../View/Form/ToggleSelect';
import ToggleCheckbox from '../View/Form/ToggleCheckBox';
import ToggleDisabled from '../View/Form/ToggleDisabled';
import ToggleRadio from '../View/Form/ToggleRadio';
import TogglePassword from '../View/Form/TogglePassword';
import DeleteItem from '../View/Form/DeleteItem';
import BtnAdd from '../View/Form/BtnAdd';
import AutoKana from '../View/Form/AutoKana';
import BtnMemberApplyCancel from '../View/Form/BtnMemberApplyCancel';
import BtnListDelete from '../View/Form/BtnListDelete';
import CalculateMutualAidPaymentPrice from '../View/Form/CalculateMutualAidPaymentPrice';
import ChangeCouncil from '../View/Form/ChangeCouncil';
import ChangeDistrict from '../View/Form/ChangeDistrict';
import ChangeGroup from '../View/Form/ChangeGroup';
import ChangeAffiliation from '../View/Form/ChangeAffiliation';
import ChangeDate from '../View/Form/ChangeDate';
import ChangeMemberType from '../View/Form/ChangeMemberType';
import BtnUpdateMasterMaintenanceTitle from '../View/Form/BtnUpdateMasterMaintenanceTitle';
import ActivateSortableJS from '../View/Form/ActivateSortableJS';
import BtnAddTitleField from '../View/Form/BtnAddTitleField';
import BtnRemoveTitleField from '../View/Form/BtnRemoveTitleField';
import Editor from '../View/Form/Editor';
import BtnPost from '../View/Form/BtnPost';
import BtnPost2 from '../View/Form/BtnPost2';
import BtnTestMail from '../View/Form/BtnTestMail';
import ReflectMemberData from '../View/Form/ReflectMemberData';
import ChangeDisplayByRadioButton from '../View/Form/ChangeDisplayByRadioButton';
import BtnRejectTransfer from '../View/Form/BtnRejectTransfer';
import BtnApproveTransfer from '../View/Form/BtnApproveTransfer';
import BtnDelete from '../View/Form/BtnDelete';
import CalculateTotalPaidMutualAid from '../View/Form/CalculateTotalPaidMutualAid';
import CalculatePaidMutualAid from '../View/Form/CalculatePaidMutualAid';
import ChangeSearchItemTransferStatus from '../View/Form/ChangeSearchItemTransferStatus';
import ChangeSearchItemTransferTask from '../View/Form/ChangeSearchItemTransferTask';
import ChangeAccidentStatus from '../View/Form/ChangeAccidentStatus';
import BtnMemberSearch from '../View/Form/BtnMemberSearch';
import CheckMemberSearchPossibility from '../View/Form/CheckMemberSearchPossibility';
import CheckOrganizationMutualAidHistorySearchPossibility from '../View/Form/CheckOrganizationMutualAidHistorySearchPossibility';
import BtnOrganizationMutualAidHistorySearch from '../View/Form/BtnOrganizationMutualAidHistorySearch';
import ReflectGroupCommitteeChairman from '../View/Form/ReflectGroupCommitteeChairman';
import CheckGetGroupCommitteeChairmanPossibility from '../View/Form/CheckGetGroupCommitteeChairmanPossibility';
import MemberSearchModal from '../View/Form/MemberSearchModal';
import CommonMemberSearchModal from '../View/Form/CommonMemberSearchModal';
import CheckCommonMemberSearchPossibility from '../View/Form/CheckCommonMemberSearchPossibility';
import BtnCommonMemberSearch from '../View/Form/BtnCommonMemberSearch';
import BtnCommonMemberSearchSelectedListener from '../View/Form/BtnCommonMemberSearchSelectedListener';
import SetCurrentIndexToModal from '../View/Form/SetCurrentIndexToModal';
import CheckAllCheckbox from '../View/Form/CheckAllCheckbox';
import CheckboxEmpty from '../View/Form/CheckboxEmpty';
import BtnUpdateMasterMaintenance from '../View/Form/BtnUpdateMasterMaintenance';
import BtnAddMasterMaintenanceItemField from '../View/Form/BtnAddMasterMaintenanceItemField';
import ChangeDenActivityStatus from '../View/Form/ChangeDenActivityStatus';
import NameDeleteGroup from '../View/Form/NameDeleteGroup';
import ChangeSupportingDen from '../View/Form/ChangeSupportingDen';
import RegisterSupporter from '../View/Form/RegisterSupporter';
import ChangeSupportingScout from '../View/Form/ChangeSupportingScout';
import ChangeSupporterRegisteredAt from '../View/Form/ChangeSupporterRegisteredAt';
import ParentContact from '../View/Form/ParentContact';
import ChangeMemberTypeOnTransfer from '../View/Form/ChangeMemberTypeOnTransfer';
import BtnCancelApplying from '../View/Form/BtnCancelApplying';
import BtnDisabledUntilRelevantFieldsEntered from '../View/Form/BtnDisabledUntilRelevantFieldsEntered';
import ChangeMemberTypeOnRevival from '../View/Form/ChangeMemberTypeOnRivival';
import ChangePublicationTo from '../View/Form/ChangePublicationTo';
import ChangePublicationAge from '../View/Form/ChangePublicationAge';
import ChangeFilterPrefecture from '../View/Form/ChangeFilterPrefecture';
import UpdateFormActionAttribute from '../View/Form/UpdateFormActionAttribute';
import ChangeContributionType from '../View/Form/ChangeContributionType';
import CopyCommentToModal from '../View/Form/CopyCommentToModal';
import BtnCancelAdditionalTileApply from '../View/Form/BtnCancelAdditionalTileApply';
import MultipleFileDrop from '../View/Form/MultipleFileDrop';
import SubmitMultipartFormData from '../View/Form/SubmitMultipartFormData';
import ManageCheckboxSelectionStatus from '../View/Form/ManageCheckboxSelectionStatus';
import BtnUpdateInternalMemo from '../View/Form/BtnUpdateInternalMemo';
import BtnUpdateJapanCouncilNotes from '../View/Form/BtnUpdateJapanCouncilNotes';
import SelectAdditionalMember from '../View/Form/SelectAdditionalMember';
import ChangeMemberIdType from '../View/Form/ChangeMemberIdType';
import CheckSupporterRegistration from '../View/Form/CheckSupporterRegistration';
import LongProcess from '../View/Form/LongProcess';
import GetTransferTarget from '../View/Form/GetTransferTarget';
import GetAdditionalTitleTarget from '../View/Form/GetAdditionalTitleTarget';
import SelectExternalRegistration from '../View/Form/SelectExternalRegistration';
import BtnGroupEasySearch from '../View/Form/BtnGroupEasySearch';
import BtnGroupEasySearch2 from '../View/Form/BtnGroupEasySearch2';
import BtnShowPasswordModal from '../View/Form/BtnShowPasswordModal';
import SetTmpPassword from '../View/Form/SetTmpPassword';
import ChangeShowInactiveGroups from '../View/Form/ChangeShowInactiveGroups';
import AnchorShowPassword from '../View/Form/AnchorShowPassword';
import ChangeListTypeSelect from '../View/Form/ChangeListTypeSelect';
import ChangeSelectedCategorizedItems from '../View/Form/ChangeSelectedCategorizedItems';
import ChangeFilteringConditionsAvailability from '../View/Form/ChangeFilteringConditionsAvailability';
import ToggleAllItemsInCategory from '../View/Form/ToggleAllItemsInCategory';

// test
import ApiTest from '../View/Form/ApiTest';

$(() => {
	const FormController = new Form();
	// validate
	$('.validate').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Validate, $e, [$e, FormController]);
	});
	// 全角→半角変換
	$('.zen2han').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ZenkakuToHankaku, $e, [$e, FormController]);
	});
	// カウンター
	$('.has-counter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(HasCounter, $e, [$e, FormController]);
	});
	// アイテム削除
	$('.btn-delete-item').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeleteItem, $e, [$e, FormController]);
	});
	// 電話番号
	$('.tel-no').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TelephoneNumber, $e, [$e, FormController]);
	});
	// submit
	$('[type=submit][data-form]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Submit, $e, [$e, FormController]);
	});
	// select2
	$('.select2').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Select2, $e, [$e, FormController]);
	});
	// select2
	$('.select2-wide').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Select2Wide, $e, [$e, FormController]);
	});
	// Air  Datepicker
	$('[data-datepicker=true]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DatePicker, $e, [$e, FormController]);
	});
	// 全てチェックする
	$('.check-all').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckAll, $e, [$e, FormController]);
	});
	// パスワードの表示・非表示切り替え
	$('.btn-toggle-password').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TogglePassword, $e, [$e, FormController]);
	});
	// アコーディオン
	$('.anchor-accordion, .accordion').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Accordion, $e, [$e, FormController]);
	});
	// セレクトでの項目表示／非表示
	$('[data-select-toggle=true]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ToggleSelect, $e, [$e, FormController]);
	});
	// checkboxでの項目表示／非表示
	$('[data-checkbox-toggle=true]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ToggleCheckbox, $e, [$e, FormController]);
	});
	// checkboxでのdisabled on/off
	$('.toggle-disabled').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ToggleDisabled, $e, [$e, FormController]);
	});
	// radioでの項目表示／非表示
	$('[data-radio-toggle=true]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ToggleRadio, $e, [$e, FormController]);
	});
	// 要素追加ボタン
	$('.btn-add').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnAdd, $e, [$e, FormController]);
	});
	//カナ自動入力
	$('.name-wrap').each(function (idx, e) {
		const $e = $(e);
		const $name_sei = $e.find('.name_sei');
		const $name_mei = $e.find('.name_mei');
		const $name_sei_kana = $e.find('.name_sei_kana');
		const $name_mei_kana = $e.find('.name_mei_kana');
		const $corporate_name = $e.find('.corporate_name');
		const $corporate_name_kana = $e.find('.corporate_name_kana');
		const $victim_name = $e.find('.victim_name');
		const $victim_name_kana = $e.find('.victim_name_kana');
		ApplyClass.apply(AutoKana, $name_sei, [$name_sei, $name_sei_kana, FormController]);
		ApplyClass.apply(AutoKana, $name_mei, [$name_mei, $name_mei_kana, FormController]);
		ApplyClass.apply(AutoKana, $corporate_name, [$corporate_name, $corporate_name_kana, FormController]);
		ApplyClass.apply(AutoKana, $victim_name, [$victim_name, $victim_name_kana, FormController]);
	});
	// 加盟員申請内容取消
	$('.btn-member-apply-cancel').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnMemberApplyCancel, $e, [$e, FormController]);
	});
	// リスト削除
	$('.btn-list-delete').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnListDelete, $e, [$e, FormController]);
	});
	// 年月変更
	$('.change-date').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDate, $e, [$e, FormController]);
	});
	// 申請区分変更
	$('.member_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeMemberType, $e, [$e, FormController]);
	});
	// 共済価格計算
	$('.btn-calculate-mutual-aid-payment-price').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CalculateMutualAidPaymentPrice, $e, [$e, FormController]);
	});
	// 連盟変更（地区取得）
	$('.council_id').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeCouncil, $e, [$e, FormController]);
	});
	// 地区変更（団取得）
	$('.district_id').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDistrict, $e, [$e, FormController]);
	});
	// 団変更（所属取得）
	$('.group_id').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeGroup, $e, [$e, FormController]);
	});
	// 所属変更（役務取得）
	$('.affiliation_id').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeAffiliation, $e, [$e, FormController]);
	});
	// 役務マスタメンテナンス更新ボタン
	$('.btn-update-master-maintenance-title').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnUpdateMasterMaintenanceTitle, $e, [$e, FormController]);
	});
	// SortableJSの適用
	Array.prototype.forEach.call(document.querySelectorAll('.sortable-list'), element => new ActivateSortableJS(element))
	// 役務入力フィールド追加ボタン
	$('.btn-add-title-field').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnAddTitleField, $e, [$e, FormController]);
	});
	// 役務入力フィールド削除ボタン
	$('.btn-remove-title-field').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnRemoveTitleField, $e, [$e, FormController]);
	});
	// EditorJS
	$('#codex-editor').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Editor, $e, [$e, FormController]);
	});
	// 掲示板投稿
	$('.btn-post').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnPost, $e, [$e, FormController]);
	});
	// メールマガジン投稿
	$('.btn-post2').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnPost2, $e, [$e, FormController]);
	});
	// テストメール送信
	$('.btn-test-mail').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnTestMail, $e, [$e, FormController]);
	});
	// 加盟員Noからデータを参照してフォームに反映する
	$('.reflect-member-data').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ReflectMemberData, $e, [$e, FormController]);
	});
	// 移籍拒否ボタン管理
	$('.btn-reject-transfer').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnRejectTransfer, $e, [$e, FormController]);
	});
	// 移籍承認ボタン管理
	$('.btn-approve-transfer').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnApproveTransfer, $e, [$e, FormController]);
	});
	// ラジオボタンによる表示切り替え
	$('.change-display-group').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDisplayByRadioButton, $e, [$e, FormController]);
	});
	// ラジオボタンによる表示切り替え（移籍画面用）
	$('.change-member-type-on-transfer').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeMemberTypeOnTransfer, $e, [$e, FormController]);
	});
	// 削除ボタン
	$('.btn-delete').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnDelete, $e, [$e, FormController]);
	});
	// 支払い済み共済金合計を算出
	$('.paid-mutual-aid-total').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CalculateTotalPaidMutualAid, $e, [$e, FormController]);
	});
	// 支払い済み共済金合計を算出する際のフォームごとのイベントセット
	$('.paid_mutual_aid_price').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CalculatePaidMutualAid, $e, [$e, FormController]);
	});
	// 検索項目「移籍状況」変更時の処理
	$('.search-item-transfer-status').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSearchItemTransferStatus, $e, [$e, FormController]);
	});
	// 検索項目「必要な手続き」変更時の処理
	$('.search-item-transfer-task').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSearchItemTransferTask, $e, [$e, FormController]);
	});
	// 事故発生状況ステータス変更
	$('#accident_status').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeAccidentStatus, $e, [$e, FormController]);
	});
	// 加盟員検索モーダルを初期で表示するかどうか
	// 加盟員検索モーダルのインスタンスを扱うクラスよりも前にする
	$('#modal-member-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(MemberSearchModal, $e, [$e, FormController]);
	});
	// 加盟員検索モーダルの検索ボタン
	$('.btn-member-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnMemberSearch, $e, [$e, FormController]);
	});
	// 加盟員検索モーダルの検索ボタン disabled 管理
	$('#modal-member-search .form-control').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckMemberSearchPossibility, $e, [$e, FormController]);
	});
	// 加盟員検索モーダルの共済加入履歴ボタン disabled 管理
	$('.organization-mutual-aid-history-search-wrap .form-control').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckOrganizationMutualAidHistorySearchPossibility, $e, [$e, FormController]);
	});
	// 加盟員検索モーダルの共済加入履歴ボタン
	$('.btn-organization-mutual-aid-history-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnOrganizationMutualAidHistorySearch, $e, [$e, FormController]);
	});
	// 団委員長情報反映ボタン disabled 管理
	$('.reflect-group-committee-chairman-wrap .group_id').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckGetGroupCommitteeChairmanPossibility, $e, [$e, FormController]);
	});
	// 団IDから団委員長情報を参照してフォームに反映する
	$('.btn-reflect-group-committee-chairman').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ReflectGroupCommitteeChairman, $e, [$e, FormController]);
	});
	// 各画面共通の加盟員検索モーダルのインスタンスを生成
	// このモーダルのインスタンスを扱うクラスよりも前にする
	$('#modal-common-member-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CommonMemberSearchModal, $e, [$e, FormController]);
	});
	// 各画面共通の加盟員検索モーダルの検索ボタン
	$('.btn-common-member-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnCommonMemberSearch, $e, [$e, FormController]);
	});
	// 各画面共通の加盟員検索モーダルの検索ボタン disabled 管理
	$('#modal-common-member-search .form-control').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckCommonMemberSearchPossibility, $e, [$e, FormController]);
	});
	// 各管理の操作担当者編集画面で操作担当者を選択したときのカスタムイベントリスナー
	$('#modal-common-member-search[data-custom-event-name="saj.selected"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnCommonMemberSearchSelectedListener, $e, [$e, FormController]);
	});
	// モーダルに現在処理中のインデックスをセットする
	$('[data-bs-toggle="modal"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SetCurrentIndexToModal, $e, [$e, FormController]);
	});
	// チェックボックスをすべてチェック状態にする
	$('.check-all-checkbox').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckAllCheckbox, $e, [$e, FormController]);
	});
	// checkboxempty の状態管理
	$('.validate[data-validate="checkboxempty"][name]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckboxEmpty, $e, [$e, FormController]);
	});
	// 追加・非表示の操作が可能なマスタメンテナンス画面の更新ボタン
	$('.btn-update-master-maintenance').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnUpdateMasterMaintenance, $e, [$e, FormController]);
	});
	// マスタメンテナンスの入力フィールドを追加する
	$('.btn-add-master-maintenance-item-field').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnAddMasterMaintenanceItemField, $e, [$e, FormController]);
	});
	// 隊が「休隊（未登録）」になったら継続起算日を disabled にする
	$('.den_activity_status').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDenActivityStatus, $e, [$e, FormController]);
	});
	// 特定のボタンを押したときにname属性を削除するグループの管理
	$('.name-delete-group').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(NameDeleteGroup, $e, [$e, FormController]);
	});
	// 隊かスカウトが選択されたとき、サポートする隊のテキストを更新する
	$('.master_den_ids').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSupportingDen, $e, [$e, FormController]);
	});
	// 隊かスカウトが選択されたとき、サポートする隊のテキストを更新する
	$('.scout_member_ids').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSupportingScout, $e, [$e, FormController]);
	});
	// サポーターの登録対象を変更したとき、サポートする隊のテキストを更新する
	$('.supporter-registered-at').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSupporterRegisteredAt, $e, [$e, FormController]);
	});
	// サポーターを団に登録する画面で必要なデータをフェッチ
	$('#form-register-supporter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(RegisterSupporter, $e, [$e, FormController]);
	});
	// 保護者携帯
	$('.page-request-apply .title_id[name=main_title_id]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ParentContact, $e, [$e, FormController]);
	});
	// 申請取り下げボタン
	$('.btn-cancel-applying').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnCancelApplying, $e, [$e, FormController]);
	});
	// 関連する項目が入力されるまでボタンをdisabledにする
	$('.btn-disabled-until-relevant-fields-entered').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnDisabledUntilRelevantFieldsEntered, $e, [$e, FormController]);
	});
	// ラジオボタンによる表示切り替え（復活画面用）
	$('.change-member-type-on-revival').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeMemberTypeOnRevival, $e, [$e, FormController]);
	});
	// 「対象」を変更したとき適切な所属・隊をセレクトボックスにはめる
	$('.publication_to').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangePublicationTo, $e, [$e, FormController]);
	});
	// 「所属」を変更したときスカウトの年齢選択を表示する
	$('.show_scout_age').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangePublicationAge, $e, [$e, FormController]);
	});
	// 「都道府県絞り込み」を変更したとき都道府県を表示する
	$('.show_filter_prefecture').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeFilterPrefecture, $e, [$e, FormController]);
	});
	// クリックで対象のフォームのaction属性を更新する
	$('.update-form-action-attribute').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(UpdateFormActionAttribute, $e, [$e, FormController]);
	});
	// 寄附行為の種別が変更されたときの制御
	$('.page-contributor-divide .contribution_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeContributionType, $e, [$e, FormController]);
	});
	// 寄附行為の種別が変更されたときの制御
	$('#modal-contribution .contribution_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeContributionType, $e, [$e, FormController]);
	});
	// モーダルにコメントをコピーする
	$('.copy-comment-to-modal').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CopyCommentToModal, $e, [$e, FormController]);
	});
	// 従申請取り下げ
	$('.btn-cancel-additional-title-apply').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnCancelAdditionalTileApply, $e, [$e, FormController]);
	});
	// 複数ファイルドロップを受け付けるフォーム
	$('.multiple-file-drop-wrap').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(MultipleFileDrop, $e, [$e, FormController]);
	});
	// multipart/form-data で submit する
	$('[data-form][data-multipart-form-data]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SubmitMultipartFormData, $e, [$e, FormController]);
	});
	// チェックボックスの状態をローカルストレージで管理する
	$('.manage-checkbox-selection-status').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ManageCheckboxSelectionStatus, $e, [$e, FormController]);
	});
	// 日本連盟内部メモ更新
	$('.btn-update-internal-memo').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnUpdateInternalMemo, $e, [$e, FormController]);
	});
	// 日本連盟内部組織メモ更新
	$('.btn-update-japan-council-notes').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnUpdateJapanCouncilNotes, $e, [$e, FormController]);
	});
	// 従登録加盟員選択
	$('#additional-title-select-member').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SelectAdditionalMember, $e, [$e, FormController]);
	});
	// サポーター登録
	$('.supporter-registration').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckSupporterRegistration, $e, [$e, FormController]);
	});
	// 加盟員登録番号変更
	$('#change_member_id_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeMemberIdType, $e, [$e, FormController]);
	});
	// 長時間送信
	$('button[type=button].long-process').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(LongProcess, $e, [$e, FormController]);
	});
	// 移籍対象者取得
	$('.page-transfer-apply-from-source-create [name=apply_type]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetTransferTarget, $e, [$e, FormController, true]);
	});
	$('.page-transfer-apply-from-destination-create [name=apply_type]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetTransferTarget, $e, [$e, FormController, true]);
	});
	$('.page-transfer-apply-from-source-create [name=member_type]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetTransferTarget, $e, [$e, FormController]);
	});
	// 銃登録対象者取得
	$('.page-additional-title-apply [name=apply_type]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetAdditionalTitleTarget, $e, [$e, FormController]);
	});
	// サポーター登録での生年月日変更
	$('.select-external-registration').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SelectExternalRegistration, $e, [$e, FormController]);
	});
	// かんたん団検索
	$('.btn-group-easy-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnGroupEasySearch, $e, [$e, FormController]);
	});
	// かんたん団検索2
	$('.btn-group-easy-search2').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnGroupEasySearch2, $e, [$e, FormController]);
	});
	// パスワードモーダル
	$('.btn-show-password-modal').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnShowPasswordModal, $e, [$e, FormController]);
	});
	// 仮パスワード設定
	$('.btn-set-tmp-password').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SetTmpPassword, $e, [$e, FormController]);
	});
	// 休止中地域含む地域取得
	$('#show_inactive_groups').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeShowInactiveGroups, $e, [$e, FormController]);
	});
	// パスワード表示
	$('.anchor-show-password').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorShowPassword, $e, [$e, FormController]);
	});
	// リスト種別
	$('#select-list-type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeListTypeSelect, $e, [$e, FormController]);
	});
	// リスト新規登録・編集時の選択中の役務管理
	$('.selected-categorized-item-count').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSelectedCategorizedItems, $e, [$e, FormController]);
	});
	// お知らせの配信対象の選択状況に応じた処理を管理
	$('.filtering-conditions-availability').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeFilteringConditionsAvailability, $e, [$e, FormController]);
	});
	// お知らせ作成時の絞り込み条件用モーダル内での全選択・解除管理
	$('.toggle-all-items-in-category').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ToggleAllItemsInCategory, $e, [$e, FormController]);
	});

	// api test
	$('[data-api-test]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ApiTest, $e, [$e, FormController]);
	});
});
